var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5L3.26365 14.7583C3.09317 14.9146 2.98213 15.1251 2.94942 15.3541L2.5 18.5L6 18L6.5 15.5L9.5 15L10 12.5L12 11.45",
    stroke: "#002E33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44221 8.93879C9.13088 8.2866 8.97865 7.5636 9.00641 6.82997C9.04904 5.70312 9.5132 4.63335 10.307 3.83241C11.1008 3.03147 12.1664 2.55776 13.2928 2.50503C14.4192 2.45231 15.5244 2.82442 16.3895 3.54771C17.2547 4.27099 17.8167 5.29273 17.9644 6.41068C18.1121 7.52862 17.8347 8.66127 17.1871 9.58443C16.5395 10.5076 15.5689 11.154 14.4674 11.3956C13.7503 11.5529 13.0118 11.5312 12.3148 11.3404C12.3529 11.3418 12.3937 11.3471 12.4356 11.3573C13.0957 11.5191 13.7896 11.5301 14.4645 11.382C15.5625 11.1411 16.5301 10.4968 17.1757 9.57645C17.8213 8.65614 18.0979 7.52699 17.9506 6.4125C17.8034 5.29801 17.2431 4.27942 16.3806 3.55837C15.5181 2.83731 14.4164 2.46635 13.2934 2.51891C12.1705 2.57147 11.1082 3.04373 10.3169 3.84219C9.52552 4.64066 9.0628 5.70713 9.0203 6.8305C8.99418 7.52092 9.12796 8.2019 9.4041 8.8229C9.42161 8.86229 9.43405 8.90154 9.44221 8.93879Z",
    stroke: "#002E33",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.e4625d4ac4efe764b8066723c4a4f31c.svg";
export { ForwardRef as ReactComponent };